import React, { useEffect, useRef } from 'react';
import { dnbComLog, LogSeverity } from '@/shared/FunctionCore';

const RevenueChart = ({ chartData, options }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    const loadGoogleCharts = () => {
      const script = document.createElement('script');
      script.src = 'https://www.google.com/jsapi';
      script.async = true; // Load asynchronously
      script.onload = () => {
        if (window.google) {
          window.google.load('visualization', '1.0', {
            'packages': ['corechart', 'line'],
            callback: drawChart
          });
        } else {
          dnbComLog(LogSeverity.ERROR, 'Failed to load google chart library.')
        }
      };

      script.onerror = () => {
        dnbComLog(LogSeverity.ERROR, 'Error loading Google Charts script.')
      };
      document.body.appendChild(script);
    };

    loadGoogleCharts();

    return () => {
      // Cleanup: Remove the script tag when the component unmounts
      const script = document.querySelector(`script[src="https://www.google.com/jsapi"]`);
      if (script) {
        script.remove();
      }
    };
  }, [chartData]);

  const drawChart = () => {
    if (!window.google || !window.google.visualization) {
      dnbComLog(LogSeverity.ERROR, 'Google chart library not loaded')
      return;
    }

    const data = window.google.visualization.arrayToDataTable(chartData);
    const chart = new window.google.visualization.LineChart(chartRef.current);
    chart.draw(data, options);
  };

  return <div ref={chartRef} style={{ width: '100%', height: '100%' }} className='d-print-h-50'></div>;
};

export default RevenueChart;
